import React, { useState } from "react";
import styled from "styled-components";
import Apple from "./assets/images/apple.png";
import Burger from "./assets/images/burger.png";
import Cake from "./assets/images/cake.png";
import Donut from "./assets/images/donut.png";
import Fries from "./assets/images/fries.png";
import Leg from "./assets/images/leg.png";
import Pasta from "./assets/images/pasta.png";
import Pizza from "./assets/images/pizza.png";
import Taco from "./assets/images/taco.png";
import NewletterModal from "../../components/modals/NewletterModal";
import BackdropWrapper from "../../components/modals/BackdropWrapper";
import { trackEvent } from "./utils/gtag";

export default function Newsletter() {
  const [backdrop, setBackdrop] = useState(false);

  const passHandler = () => {
    setBackdrop((prev) => !prev);
  };

  const handleEvent = (action, label) =>{
    trackEvent(action, 'Feature Interaction', label)
  }

  return (
    <>
      <BackdropWrapper
        handleBackdrop={passHandler}
        smallSize={true}
        element={<NewletterModal backdropHandler={passHandler} />}
        open={backdrop}
      />

      <StyledNewsletter>
        <div className="newsletter_container">
          <h3>Ready to Share Your Culinary Passion?</h3>
          <p>
            Join thousands of creators and transform the way you share recipes
            today.
          </p>
          <button onClick={()=>{
            passHandler();
            handleEvent('Creators-Landing', 'Subscribe to Newsletter');
          }}>Subscribe to Newsletter</button>
        </div>
        <div className="svg_background">
          <img src={Apple} alt="Apple" className="apple" />
          <img src={Burger} alt="Burger" className="burger" />
          <img src={Cake} alt="Cake" className="cake" />
          <img src={Donut} alt="Donut" className="donut" />
          <img src={Fries} alt="Fries" className="fries" />
          <img src={Leg} alt="Leg" className="leg" />
          <img src={Pasta} alt="Pasta" className="pasta" />
          <img src={Pizza} alt="Pizza" className="pizza" />
          <img src={Taco} alt="Taco" className="taco" />
        </div>
      </StyledNewsletter>
    </>
  );
}

const StyledNewsletter = styled.div`
  height: 40vh;
  background-color: var(--primary-color);
  margin: var(--section-margin) auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .newsletter_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    flex-direction: column;
    z-index: 1;

    h3 {
      color: white;
      text-align: center;
    }

    p {
      color: white;
      text-align: center;
    }

    button {
      background-color: var(--secondary-color);
      border-radius: var(--l-radius);
      &:hover {
        background-color: var(--secondary-color-light);
      }
    }
  }

  .svg_background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .svg_background > img {
    position: absolute;
    opacity: 0.5;
    max-width: 54px;
  }

  .apple {
    top: 10%;
    left: 10%;
  }

  .burger {
    top: 10%;
    left: 70%;
  }

  .cake {
    top: 50%;
    left: 18%;
  }

  .donut {
    top: 25%;
    left: 80%;
  }

  .fries {
    top: 70%;
    left: 25%;
  }

  .leg {
    top: 25%;
    left: 25%;
  }

  .pasta {
    top: 65%;
    left: 70%;
  }

  .pizza {
    top: 75%;
    left: 85%;
  }

  .taco {
    top: 25%;
    left: 50%;
  }

  .wrap {
    top: 60%;
    left: 2%;
  }

  @media (max-width: 640px) {
    .svg_background > img {
      width: 10;
    }
  }
`;
